import { Component } from '@angular/core';

@Component({
    selector: 'msc-hub',
    templateUrl: './hub.component.html'
})
export class HubComponent {}
